import { useAuth } from '@pesto/features/src/providers/AuthProvider/AuthProvider';

import { useCurrentUserQuery, UserRole } from '../__generated__/graphql/api';
import { useIsPublicRoute } from './useIsPublicRoute';

export const useRole = () => {
  const { isAuthenticated } = useAuth();
  const isPublicRoute = useIsPublicRoute();
  const { data } = useCurrentUserQuery({ skip: isPublicRoute || !isAuthenticated() });
  const role = data?.currentUser?.role ?? null;

  return {
    role,
    isPartnerAdmin: role === UserRole.PartnerAdmin,
  };
};
